import React, { useState, useEffect, useContext } from "react";
import OrgTabPageShell from "../OrgTabPageShell";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import orgStyles from "../../orgSettings.module.css";
import { Typography, Card, message, Button } from "antd";
import { TagsInput } from "react-tag-input-component";
import { addCinApi, addGstApi } from "../../../../services/auth.services";
import { UserContext } from "../../../../context/UserContext";
import { getCookie } from "../../../../helpers/localStorage";
import { Role } from "../../../../constants/defaultKeys";
import useIsMobile from "../../../../hooks/useIsMobile";

const cinRegex = /^[U,L]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/;
const gstRegex =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

const Additional = ({ data, sideContent }) => {
  const { userDetails } = useContext(UserContext);
  const isMobile = useIsMobile();
  const [cin, setCin] = useState(data ? [...data?.cin_nos] : []);
  const [gst, setGst] = useState(data ? [...data?.gstin_nos] : []);

  useEffect(() => {
    if (data) {
      setCin(data?.cin_nos);
      setGst(data?.gstin_nos);
    }
  }, [data]);

  const defaultRole = userDetails?.currRole || getCookie(Role);
  const isOrgAdminOrOwner =
    defaultRole === "Organization_Owner" ||
    defaultRole === "Organization_Admin";

  const onCinSubmit = () => {
    if (!cin?.length) return message.error("Please add cin");
    addCinApi(cin)
      .then((res) => message.success(res?.data?.message))
      .catch((err) => message.error(err?.response?.data?.message));
  };

  const onGstSubmit = () => {
    if (!gst?.length) return message.error("Please add gst");
    addGstApi(gst)
      .then((res) => message.success(res?.data?.message))
      .catch((err) => message.error(err?.response?.data?.message));
  };

  const handleBeforeCinAddValidate = (tag) => {
    if (!cinRegex.test(tag)) {
      message.error("Please enter valid 21 digits alpha-numeric cin number");
      return false;
    }
    return true;
  };

  const handleBeforeGstAddValidate = (tag) => {
    if (!gstRegex.test(tag)) {
      message.error("Please enter valid GST number");
      return false;
    }
    return true;
  };

  return (
    <OrgTabPageShell sideContent={sideContent}>
      <Card className={`${orgStyles.orgProfileCardWide} centeredCard`}>
        <div className={`${orgStyles.orgForm} ${orgStyles.orgTagsForm}`}>
          <Typography>CIN</Typography>
          <TagsInput
            disabled={!isOrgAdminOrOwner}
            separators={[",", "Enter"]}
            value={cin}
            onChange={setCin}
            placeHolder={
              isMobile
                ? "Enter CIN, then press Enter"
                : "Enter CIN numbers followed by (,)"
            }
            beforeAddValidate={handleBeforeCinAddValidate}
          />
          {isOrgAdminOrOwner && (
            <div
              className="flex-end"
              style={{ gap: "24px", marginTop: "10px" }}
            >
              <Button
                className={btnStyles.mdBtn}
                type="primary"
                onClick={onCinSubmit}
              >
                Save CIN
              </Button>
            </div>
          )}

          <Typography style={{ marginTop: 16 }}>GST</Typography>
          <TagsInput
            disabled={!isOrgAdminOrOwner}
            separators={[",", "Enter"]}
            value={gst}
            onChange={setGst}
            placeHolder={
              isMobile
                ? "Enter GST, then press Enter"
                : "Enter GST numbers followed by (,)"
            }
            beforeAddValidate={handleBeforeGstAddValidate}
          />
          {isOrgAdminOrOwner && (
            <div
              className="flex-end"
              style={{ gap: "24px", marginTop: "10px" }}
            >
              <Button
                className={btnStyles.mdBtn}
                type="primary"
                onClick={onGstSubmit}
              >
                Save GST
              </Button>
            </div>
          )}
        </div>
      </Card>
    </OrgTabPageShell>
  );
};

export default Additional;
